var _circle, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSlackinline = function SvgSlackinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "slack_inline_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 26,
    width: 52,
    height: 52
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#slack_inline_svg__a)",
    d: "M26 26h52v52H26z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#slack_inline_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.07 26a5.2 5.2 0 1 0 0 10.4h5.2v-5.2a5.19 5.19 0 0 0-1.521-3.675A5.212 5.212 0 0 0 45.069 26Zm0 13.866H31.2a5.2 5.2 0 1 0 0 10.4h13.87a5.2 5.2 0 1 0 0-10.4Z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.001 45.066a5.201 5.201 0 0 0-10.402 0v5.2h5.2a5.212 5.212 0 0 0 3.68-1.525 5.19 5.19 0 0 0 1.522-3.675Zm-13.869 0V31.2a5.19 5.19 0 0 0-1.521-3.675 5.2 5.2 0 0 0-8.88 3.675v13.866a5.2 5.2 0 1 0 10.401.001",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.931 78a5.212 5.212 0 0 0 3.68-1.524 5.19 5.19 0 0 0 1.521-3.675 5.19 5.19 0 0 0-1.521-3.675 5.212 5.212 0 0 0-3.68-1.525h-5.2v5.2a5.2 5.2 0 0 0 5.2 5.2Zm0-13.865h13.87a5.201 5.201 0 0 0-.001-10.4H58.93a5.2 5.2 0 1 0 0 10.399",
    fill: "#ECB22E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 58.934a5.184 5.184 0 0 0 1.521 3.675 5.204 5.204 0 0 0 7.36 0 5.19 5.19 0 0 0 1.52-3.675v-5.2h-5.2a5.2 5.2 0 0 0-5.201 5.2Zm13.869 0V72.8a5.2 5.2 0 0 0 10.401 0V58.935a5.185 5.185 0 0 0-1.52-3.675 5.207 5.207 0 0 0-3.68-1.525 5.2 5.2 0 0 0-5.201 5.2Z",
    fill: "#E01E5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "slack_inline_svg__a",
    x1: 78,
    y1: 26,
    x2: 26,
    y2: 78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F3F3",
    stopOpacity: 0.8
  })))));
};
export default SvgSlackinline;